import * as React from 'react';
import { Glass } from './Glass';
import { IsInButtonGroupProvider } from 'hooks/isInButtonGroup';
import { ViewProps } from 'react-native';

type Props = {
  backgroundColor?: string;
  disabled?: boolean;
  children?: React.ReactNode;
  style?: ViewProps['style'];
  glass?: boolean;
};

export const ButtonGroup = ({
  children,
  backgroundColor,
  disabled,
  style,
  glass = true,
}: Props) => {
  return (
    <IsInButtonGroupProvider value={true}>
      <Glass
        key={disabled ? 'd' : 'a'}
        disabled={disabled}
        backgroundColor={backgroundColor}
        glass={glass}
        style={[
          {
            borderRadius: 99,
            flexDirection: 'row',
            alignItems: 'center',
          },
          style,
        ]}
      >
        {children}
      </Glass>
    </IsInButtonGroupProvider>
  );
};
